if (!customElements.get('tpt-customtext')) {
	customElements.define(
		'tpt-customtext',
		class TptCustomText extends HTMLElement {
			connectedCallback() {
				const lines = parseInt(this.getAttribute('lines'), 10) || 5;
				const viewMoreText = this.getAttribute('view-more') || 'View more';
				const viewLessText = this.getAttribute('view-less') || 'View less';

				const originalContent = this.innerHTML.trim();

				this.innerHTML = `
                    <div class="tpt-customtext__content">
                    ${originalContent}
                    </div>
                    <button
                    class="tpt-customtext__toggle"
                    type="button"
                    aria-expanded="false"
                    hidden
                    >
                    ${viewMoreText}
                    </button>
                `;

				const contentEl = this.querySelector('.tpt-customtext__content');
				const toggleBtn = this.querySelector('.tpt-customtext__toggle');

				// Base styles
				const lineHeight = parseFloat(getComputedStyle(contentEl).lineHeight);

				Object.assign(contentEl.style, {
					display: '-webkit-box',
					WebkitBoxOrient: 'vertical',
					WebkitLineClamp: lines,
					overflow: 'hidden',
				});

				// ---- CHECK IF CONTENT OVERFLOWS ----
				requestAnimationFrame(() => {
					const maxHeight = lineHeight * lines;

					if (contentEl.scrollHeight > maxHeight + 1) {
						// Content longer than X lines → show button
						toggleBtn.hidden = false;
					} else {
						// Content short → remove clamp completely
						contentEl.style.WebkitLineClamp = 'unset';
					}
				});

				// Toggle handler
				toggleBtn.addEventListener('click', () => {
					const expanded = toggleBtn.getAttribute('aria-expanded') === 'true';

					toggleBtn.setAttribute('aria-expanded', String(!expanded));

					if (!expanded) {
						contentEl.style.WebkitLineClamp = 'unset';
						toggleBtn.textContent = viewLessText;
					} else {
						contentEl.style.WebkitLineClamp = lines;
						toggleBtn.textContent = viewMoreText;
					}
				});
			}
		},
	);
}
